$(document).ready(function(){
    $('.wp-block-navigation.mobile-collapse').each(function(index){
        var $nav = $(this);
        var $mobileLabel = $nav.find('.current-menu-item a').first().clone();
        var collapseId = 'mobile-collapse-' + index;
        $mobileLabel.prependTo($nav)
                .addClass('mobile-label collapsed')
                .attr('data-bs-toggle','collapse')
                .attr('aria-expanded','false')
                .attr('aria-controls', collapseId)
                .attr('href', '#' + collapseId);
        $nav.children('ul').addClass('collapse').attr('id', collapseId);
    });
});